export enum FileTypeIconName {
  DOC = 'DOC',
  TABLE = 'TABLE',
  CODE = 'CODE',
  JSON = 'JSON',
  ZIP = 'ZIP',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  PDF = 'PDF',
  ANDROID = 'ANDROID',
  AUDIO = 'AUDIO',
}

export function mapMimeTypeToFileTypeIcon(mimeType: string): FileTypeIconName {
  const [primaryType] = mimeType.split('/');

  switch (primaryType) {
    case 'image':
      return FileTypeIconName.IMAGE;
    case 'video':
      return FileTypeIconName.VIDEO;
    case 'audio':
      return FileTypeIconName.AUDIO;
    default:
      break;
  }

  if (mimeType === 'application/json') {
    return FileTypeIconName.JSON;
  }
  if (mimeType === 'application/pdf') {
    return FileTypeIconName.PDF;
  }
  if (mimeType.includes('xml')) {
    return FileTypeIconName.CODE;
  }
  if (mimeType === 'text/csv') {
    return FileTypeIconName.TABLE;
  }
  if (mimeType.includes('zip') || mimeType.includes('tar') || mimeType.includes('gzip') || mimeType.includes('rar')) {
    return FileTypeIconName.ZIP;
  }
  if (mimeType.includes('android')) {
    return FileTypeIconName.ANDROID;
  }

  return FileTypeIconName.DOC;
}
